import React, { useRef, useState } from "react";
import { Button, Col, Nav, Row, Tab, Spinner } from "react-bootstrap";

// css
import "./tutorial.scss";
import {
  useFetchTutorialPageQuery,
  useFetchUserProfileQuery,
} from "store/services/user.service";
import VideoModal from "./modal/VideoModal";
import Loader from "components/shared/Loader";
import ErrorComponent from "components/shared/ErrorComponent";

const TutorialSec = () => {
  const videoRef = useRef(null);
  const [play, setPlay] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState("");

  const { data: tutorialData, isLoading, isError } = useFetchTutorialPageQuery();
  const { data: userProfile } = useFetchUserProfileQuery(undefined);

  const handleShowModal = (videoUrl) => {
    setSelectedVideo(videoUrl);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedVideo("");
  };



  const videoTutorials = tutorialData?.items?.length ?
    tutorialData.items.filter(
      (item) => item.media_type === "video"
    ) :
    [];

  const freeTutorials = videoTutorials.filter((item) => !item.paid);
  const paidTutorials = videoTutorials.filter((item) => item.paid);

  return (
    <div className="inner">
      <Row>
        <Col lg="12" className="my-2">
          {isLoading ? (
            <Loader />
          ) : isError ? (
            <ErrorComponent />
          ) : (
            <Tab.Container id="left-tabs-example" defaultActiveKey="Free">
              <Nav variant="pills" className="ActiveTextTab gap-10 pb-2">
                <Nav.Item className="px-2">
                  <Nav.Link
                    className="position-relative px-0 pb-1 bg-transparent border-0 pt-0 fw-sbold"
                    eventKey="Free"
                  >
                    Free Tutorial
                  </Nav.Link>
                </Nav.Item>
                {userProfile?.isSubscribed && (
                  <Nav.Item className="px-2">
                    <Nav.Link
                      className="position-relative px-0 pb-1 bg-transparent border-0 pt-0 fw-sbold"
                      eventKey="Paid"
                    >
                      Paid Tutorial
                    </Nav.Link>
                  </Nav.Item>
                )}
              </Nav>
              <Tab.Content className="py-2">
                <Tab.Pane eventKey="Free">
                  <Row className="tutorialsec">
                    {freeTutorials.map((tutorial) => (
                      <Col lg="12" className="my-2" key={tutorial._id}>
                        <div className="d-flex align-items-center justify-content-between gap-10">
                          <div className="left">
                            <h5 className="m-0 text-dark">{tutorial.title}</h5>
                            <p className="m-0 text-dark">
                              {tutorial.description}
                            </p>
                          </div>
                        </div>
                        <div className="MediaWrpper position-relative mt-3">
                          <video
                            className="w-100"
                            ref={videoRef}
                            poster={tutorial.thumbnail}
                          >
                            <source src={tutorial.media} type="video/mp4" />
                            <source src={tutorial.media} type="video/webm" />
                          </video>
                          <Button
                            className="rounded-pill d-inline-flex align-items-center justify-content-center p-0 position-absolute"
                            variant="transparent"
                            onClick={() => handleShowModal(tutorial.media)}
                          >
                            Play
                          </Button>
                        </div>
                      </Col>
                    ))}
                  </Row>
                </Tab.Pane>
                {userProfile?.isSubscribed && (
                  <Tab.Pane eventKey="Paid">
                    <Row className="tutorialsec">
                      {paidTutorials.map((tutorial) => (
                        <Col lg="12" className="my-2" key={tutorial._id}>
                          <div className="d-flex align-items-center justify-content-between gap-10">
                            <div className="left">
                              <h5 className="m-0 text-dark">{tutorial.title}</h5>
                              <p className="m-0 text-dark">
                                {tutorial.description}
                              </p>
                            </div>
                          </div>
                          <div className="MediaWrpper position-relative mt-3">
                            <video
                              className="w-100"
                              ref={videoRef}
                              poster={tutorial.thumbnail}
                            >
                              <source src={tutorial.media} type="video/mp4" />
                              <source src={tutorial.media} type="video/webm" />
                            </video>
                            <Button
                              className="rounded-pill d-inline-flex align-items-center justify-content-center p-0 position-absolute"
                              variant="transparent"
                              onClick={() => handleShowModal(tutorial.media)}
                            >
                              Play
                            </Button>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Tab.Pane>
                )}
              </Tab.Content>
            </Tab.Container>
          )}
        </Col>
      </Row>
      <VideoModal
        show={showModal}
        handleClose={handleCloseModal}
        videoUrl={selectedVideo}
      />
    </div>
  );
};

export default TutorialSec;
